import HelmetMetaData from "@/components/HelmetMetaData";
import { TriangleAlert } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <HelmetMetaData
        title="Page Not Found - 404 Error"
        description="We're sorry, but the page you're looking for cannot be found. Please check the URL or navigate back to our homepage."
      />

      <div className="flex h-[100dvh] items-center justify-center bg-green-50">
        <div className="flex shrink-0 flex-col items-center">
          <img
            src="/logo-image-black.svg"
            alt="logo"
            className="w-[150px] lg:w-[150px]"
          />

          <h1 className="font-jakarta text-[80px] leading-[1.1] font-black text-black/80 md:text-[150px] md:leading-[150px]">
            404
          </h1>

          <div className="mx-auto flex md:items-start md:justify-start">
            <div className="hidden pt-1 md:block">
              <TriangleAlert
                color="#FFAB2D"
                className="size-[22px] md:size-[50px]"
              />
            </div>

            <p className="m-0 flex max-w-sm items-start p-0 text-center text-[20px] leading-[1.2] font-medium text-black/80 md:max-w-lg md:text-[40px]">
              {" "}
              <TriangleAlert
                color="#FFAB2D"
                className="size-[25px] md:hidden md:size-[45px]"
              />
              The page you were looking for is not found!
            </p>
          </div>

          <p className="my-2 max-w-sm text-center text-sm leading-[1.8] text-[#727272] md:max-w-xl md:text-base">
            You may have mistyped the address or the page may have moved.
          </p>

          <button
            onClick={() => navigate("/dashboard")}
            className="bg-primary w-fit rounded-lg px-[16px] py-[8px] text-[13px] font-medium text-white outline-none lg:my-4"
          >
            Back to Home
          </button>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
